import react, {useRef} from "react";

const InputUploadImage = ({ onChange, props }) => {
    const inputFile = useRef(null);

    const onButtonClick = () => {
        // `current` points to the mounted file input element
        inputFile.current.click();
      };


    return (
        <div className="InputUploadImage-box">
            <input
                className="InputUploadImage"
                type="file"
                name="myImage"
                onChange={onChange}
                multiple
                ref={inputFile}
                {...props}
            />
            <span onClick={onButtonClick}><i className="fa-solid fa-plus"></i></span>
        </div>

    )
}

export default InputUploadImage;